import { render, staticRenderFns } from "./UsersDropdown.vue?vue&type=template&id=50961320&"
import script from "./UsersDropdown.vue?vue&type=script&lang=ts&"
export * from "./UsersDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports